export default class Builder {
    baseUrl = `${process.env.MIX_APP_URL}/api`;

    includes = [];

    filters = [];

    layout = null;

    sort = null;

    append = [];

    page = null;

    limit = null;

    queryParams = [];

    url = '';

    whereIn(field, values) {
        this.filters.push({ field, value: values.join(',') });
    }

    where(field, value) {
        this.filters.push({ field, value });
    }

    query(field, value) {
        this.queryParams.push({ field, value });
    }

    orderBy(field, direction = 'asc') {
        if (direction === 'desc') {
            this.sort = `-${field}`;
        } else {
            this.sort = field;
        }
    }

    getParams() {
        const params = {
            params: {
                include: this.includes.filter(Boolean).join(','),
                layout: this.layout,
                sort: this.sort,
                per_page: this.limit,
                ...this.queryParams.reduce((acc, { field, value }) => {
                    // eslint-disable-next-line no-param-reassign
                    acc[field] = value;
                    return acc;
                }, {}),
            },
        };

        // the filters need to be added to the params object
        this.filters.forEach((filter) => {
            // if the filter.value is an object, we need to add each key as a filter
            if (filter.value !== null && typeof filter.value === 'object') {
                Object.keys(filter.value).forEach((key) => {
                    params.params[`filter[${filter.field}][${key}]`] = filter.value[key];
                });
                return;
            }

            params.params[`filter[${filter.field}]`] = filter.value;
        });

        // strip out empty or undefined params
        Object.keys(params.params).forEach((key) => {
            if (params.params[key] === undefined || params.params[key] === '') {
                delete params.params[key];
            }
        });

        return params;
    }
}
